import { render, staticRenderFns } from "./CBAG1010.vue?vue&type=template&id=70c5d840&scoped=true"
import script from "./CBAG1010Controller.ts?vue&type=script&lang=ts&external"
export * from "./CBAG1010Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CBAG1010.vue?vue&type=style&index=0&id=70c5d840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5d840",
  null
  
)

export default component.exports